var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable brace-style, comma-dangle, indent, react/jsx-closing-bracket-location, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var Changeable = require("../mixins/changeable.jsx");
var _ = require("underscore");

var ApiOptions = require("../perseus-api.jsx").Options;
var EditorJsonify = require("../mixins/editor-jsonify.jsx");
var PropCheckBox = require("../components/prop-check-box.jsx");
var TextListEditor = require("../components/text-list-editor.jsx");

var Categorizer = require("./categorizer.jsx").widget;

var CategorizerEditor = React.createClass({
    displayName: "CategorizerEditor",

    propTypes: _extends({}, Changeable.propTypes, {
        apiOptions: ApiOptions.propTypes,
        items: React.PropTypes.arrayOf(React.PropTypes.string),
        categories: React.PropTypes.arrayOf(React.PropTypes.string),
        values: React.PropTypes.arrayOf(React.PropTypes.number),
        randomizeItems: React.PropTypes.bool
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            items: [],
            categories: [],
            values: [],
            randomizeItems: false
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    render: function render() {
        var _this = this;

        return React.createElement(
            "div",
            null,
            React.createElement(
                "div",
                { className: "perseus-widget-row" },
                React.createElement(PropCheckBox, {
                    label: "Randomize item order",
                    labelAlignment: "right",
                    randomizeItems: this.props.randomizeItems,
                    onChange: this.props.onChange
                })
            ),
            "Categories:",
            React.createElement(TextListEditor, {
                options: this.props.categories,
                onChange: function onChange(cat) {
                    _this.change("categories", cat);
                },
                layout: "horizontal"
            }),
            "Items:",
            React.createElement(TextListEditor, {
                options: this.props.items,
                onChange: function onChange(items) {
                    _this.change({
                        items: items,
                        // TODO(eater): This truncates props.values so there
                        // are never more correct answers than items,
                        // ensuring the widget is possible to answer
                        // correctly. It doesn't necessarly keep each
                        // answer with its corresponding item if an item
                        // is deleted from the middle. Inconvenient, but
                        // it's at least possible for content creators to
                        // catch and fix.
                        values: _.first(_this.props.values, items.length)
                    });
                },
                layout: "vertical"
            }),
            React.createElement(Categorizer, {
                apiOptions: this.props.apiOptions,
                items: this.props.items,
                categories: this.props.categories,
                values: this.props.values,
                onChange: function onChange(newProps) {
                    _this.props.onChange(newProps);
                },
                trackInteraction: function trackInteraction() {}
            })
        );
    },

    serialize: function serialize() {
        return EditorJsonify.serialize.call(this);
    }
});

module.exports = CategorizerEditor;


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/categorizer-editor.jsx
 ** module id = 95
 ** module chunks = 0 1
 **/